import { validateEmail } from "../counterparties";
import { smtpPorts } from "./labels";

/** Ссылка на секрет, которую принимает Core: имя переменной окружения или Docker secret. */
const credentialReferencePattern = /^(env|docker-secret):[A-Za-z0-9_.-]+$/;

export function validateName(value: string): string | null {
  const name = value.trim();
  if (name === "") return "Укажите название ящика";
  return name.length > 160 ? "Название длиннее 160 символов" : null;
}

export function validateMailboxEmail(value: string): string | null {
  const problem = validateEmail(value);
  if (problem !== null) return problem;
  return value.trim().length > 320 ? "Адрес длиннее 320 символов" : null;
}

export function validateHost(value: string, required: boolean): string | null {
  const host = value.trim();
  if (host === "") return required ? "Укажите сервер" : null;
  if (host.length > 255) return "Адрес сервера длиннее 255 символов";
  return /^[A-Za-z0-9]([A-Za-z0-9.-]*[A-Za-z0-9])?$/.test(host)
    ? null
    : "Сервер указывают именем хоста без схемы и порта, например imap.example.com";
}

export function validateImapPort(value: string): string | null {
  const port = Number(value);
  return Number.isInteger(port) && port >= 1 && port <= 65535
    ? null
    : "Порт IMAP — число от 1 до 65535";
}

export function validateSmtpPort(value: string): string | null {
  return smtpPorts.some((port) => String(port) === value)
    ? null
    : "Core принимает для SMTP только порты 465 и 587";
}

export function validateCredentialReference(value: string): string | null {
  const reference = value.trim();
  if (reference === "") return null;
  if (reference.length > 255) return "Ссылка длиннее 255 символов";
  return credentialReferencePattern.test(reference)
    ? null
    : "Ссылка должна начинаться с «env:» или «docker-secret:», дальше — имя из букв, цифр, «.», «_» и «-»";
}

export function validateCredentialSecret(value: string): string | null {
  if (value === "") return null;
  if (value.length < 8) return "Пароль короче 8 символов";
  return value.length > 255 ? "Пароль длиннее 255 символов" : null;
}

export function validateFailureNote(value: string): string | null {
  const note = value.trim();
  if (note === "") return "Опишите, как разобрана ошибка";
  return note.length > 10000 ? "Заметка длиннее 10 000 символов" : null;
}
